import { createAction, props } from "@ngrx/store";
import { HEADER } from "./header.constants";

export const updateHeaderTitle = createAction(HEADER.UPDATE_HEADER, props<{ title: string }>());
export const updateHeaderIcon = createAction(HEADER.UPDATE_HEADER_ICON, props<{ icon: string }>());
